// extracted by mini-css-extract-plugin
export default {"wrapper":"SSbkbH2EqP","controls":"hYoBx_J7AO","control":"GLa16IhlAs","label":"wBF58SqrDi","settingsControl":"ILB2tRZWtH","dark":"a48jnjJs1n"};